<template>
  <g
    :id="`area-${area.id}`"
    :class="{
      'map-area': true,
      'is-active': selected,
      'is-accepted': area.accepted,
      'is-pending': !area.accepted,
    }"
    :transform="transform"
    @click.stop="onClick"
  >
    <path v-for="path in area.svg_paths.paths" :d="path" />
  </g>
</template>

<script setup>
  import { ref, computed, onMounted, watch, inject } from "vue";

  const props = defineProps({
    transform: {
      type: String,
      required: false,
      default: "scale(1, -1)"
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    }
  });

  const emit = defineEmits(["click"]);
  const area = defineModel();
  const zooms = inject("mapZooms");
  const zoom = inject("mapZoom");

  const areaStrokeWidth = computed(() => {
    const maxZoom = Math.max(...zooms.value.map(z => z.zoom)) + 1;
    return 3 * (maxZoom - zoom.value);
  });

  function onClick() {
    emit("click", area.value);
  }
</script>

<style scoped>
  .map-area {
    cursor: pointer;
    color: #ffcc44;
  }

  .map-area.is-accepted {
    color: #99ff00;
  }

  .map-area.is-active {
    color: #ff0000;
  }

  .map-area path {
    fill: #11111101;
    stroke: currentColor;
    stroke-width: v-bind(areaStrokeWidth);
    transition: fill 120ms ease-in-out;
  }

  .map-area:hover path {
    fill: currentColor;
    fill-opacity: 0.4;
  }
</style>
